import EventsEmitter from '../services/eventsEmitter';

export const gameEvents = new EventsEmitter();

export function addToGameEvents(eventsInfo, context) {
  const unsubscribers = [];
  for (const event in eventsInfo) {
    const callback = eventsInfo[event];
    unsubscribers.push(gameEvents.on(event, callback, context));
  }
  return unsubscribers;
}
